<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/wishlists/shared/wishlists-link/wishlists-link.component.ts
-->
<ng-template #anchor></ng-template>
